import classNames from "classnames";
import React, { JSX } from "react";
import { useTranslation } from "react-i18next";

import style from "./license-key-filtering.scss";
import { LicenseKeyFilter } from "domain/licenseKeys";
import layoutStyle from "styles/layout.scss";

import testIds from "testIds.json";

interface Props {
    filterType: LicenseKeyFilter;
    resultsCount: number;
    setFilterType: (filterType: LicenseKeyFilter) => void;
}

export function LicenseKeysFiltering(props: Props): JSX.Element {
    const { t } = useTranslation();
    function generateFilterOptions() {
        const filterToTranslation = new Map<LicenseKeyFilter, string>([
            [LicenseKeyFilter.ALL, t("LicenseKeys.allKeys")],
            [LicenseKeyFilter.ACTIVE, t("LicenseKeys.activeKeys")],
            [LicenseKeyFilter.DISABLED, t("LicenseKeys.deactivatedKeys")],
            [LicenseKeyFilter.EXPIRED, t("LicenseKeys.expiredKeys")],
            [LicenseKeyFilter.USED, t("LicenseKeys.usedKeys")],
        ]);
        return Object.keys(LicenseKeyFilter).map((filter) => {
            return (
                <button
                    onClick={() => {
                        handleFilterClick(filter as LicenseKeyFilter);
                    }}
                    key={filter}
                    className={classNames(style.quickFilterButton, {
                        [style.active]: props.filterType === filter,
                    })}
                    data-testid={testIds.common.primaryView.table.filter.button}
                    data-type={filter}
                >
                    {filterToTranslation.get(filter as LicenseKeyFilter)}
                </button>
            );
        });
    }
    function handleFilterClick(filter: LicenseKeyFilter) {
        props.setFilterType(filter);
    }
    return (
        <div className={classNames(layoutStyle.recordCount, style.quickFilterContainer)}>
            <div data-testid={testIds.common.primaryView.table.filter.itself}>{generateFilterOptions()}</div>
            <div> {t("Common.recordsCount", { dataCount: props.resultsCount })}</div>
        </div>
    );
}
